import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {BillingParty} from '../../../graphql/billing_party.datatypes';

interface BillingPartiesData {
    allBillingParties: BillingParty[]
}

const GET_ALL_BILLING_PARTIES_QUERY = gql`
  query getBillingPartyPayingMembers($where: WhereConditions, $hasGroupBooking: QueryAllBillingPartiesHasGroupBookingWhereHasConditions, $hasBillingPartyMember: QueryAllBillingPartiesHasBillingPartyMemberWhereHasConditions, $orderBy: [OrderByClause!]){
    allBillingParties(where: $where, hasGroupBooking: $hasGroupBooking, hasBillingPartyMember: $hasBillingPartyMember, orderBy: $orderBy){
      id
      payingMembers {
        id
        primary_paying_member
        first_name
        last_name
        email
      }
    }
  }
`;

export const getBillingPartyPayingMembers = (where?: any, orderBy?: any, hasGroupBooking?: any, hasBillingPartyMember?: any) => useQuery<BillingPartiesData>(
    GET_ALL_BILLING_PARTIES_QUERY,
    {
        variables: {
            where,
            hasGroupBooking,
            hasBillingPartyMember,
            orderBy,
        },
    }
);

export default getBillingPartyPayingMembers;
